import InfoSolidIcon from '@eduzz/houston-icons/InfoSolid';
import {
  Icon,
  InputLabel,
  Input,
  InputAdornment,
  IconButton,
  CircularProgress,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Tooltip,
  Typography,
} from '@material-ui/core';
import MyCollapse from 'components/Collapse';
import CustomCopyToClipboard from 'components/CustomCopyToClipboard';
import PermissionHide from 'components/PermissionHide';
import { functions } from 'helpers';
import { constants } from 'helpers/constants';
import React from 'react';
import { Link } from 'react-router-dom';
import { useObservable } from 'react-use-observable';
import { HOST_ORBITA, URL_SELECT, VERTICAL_URL } from 'settings';
import { AllBeltsId } from 'v2/interfaces/elite';
import eduzzAccountsService from 'v2/services/eduzzAccount';

import { ProductChangeHistory } from './ProductChangeHistory';
import QuickViewLinks from './QuickviewLinks';

type Props = {
  statusProduct: 'active' | 'inactive' | 'filed' | 'draft' | ' ';
  productDataReceive: any;
  physicalProductPending: boolean;
  copiedCheckout: () => void;
  handleChange: (props: any, event: any) => void;
  inputInviteAffiliate: string;
  productData: any;
  isValid: (field: any) => boolean;
  handleClickInviteAffiliate: () => void;
  productInviteAffiliate: any;
  errorFor: (field: any) => any;
  handleClickGetAffiliatesProductStatusSummary: () => void;
  affiliatesProductStatusSummary: any;
  approvedAffiliatesAmount: number;
  disapprovedAffiliatesAmount: number;
  pendingAffiliatesAmount: number;
  cantManualDelivery: any;
  inputDeliveryError: boolean;
  inputDelivery: string;
  handleClickDelivery: () => void;
  productDelivery: any;
  handleClickGetInvoice: () => void;
  productInvoice: any;
};

const couponStyle = {
  textDecoration: 'none',
  color: '#596375',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
  padding: '0.75rem 1rem',
  border: '1px solid #EEE',
  background: 'white',
  borderRadius: '4px',
};

const QuickActions = ({
  productDataReceive,
  statusProduct,
  physicalProductPending,
  copiedCheckout,
  handleChange,
  inputInviteAffiliate,
  productData,
  isValid,
  handleClickInviteAffiliate,
  productInviteAffiliate,
  errorFor,
  handleClickGetAffiliatesProductStatusSummary,
  affiliatesProductStatusSummary,
  approvedAffiliatesAmount,
  disapprovedAffiliatesAmount,
  pendingAffiliatesAmount,
  cantManualDelivery,
  inputDeliveryError,
  inputDelivery,
  handleClickDelivery,
  productDelivery,
  handleClickGetInvoice,
  productInvoice,
}: Props) => {
  const { id, has_children, parent_product, charge_type, type } = productDataReceive;

  const [user] = useObservable(() => eduzzAccountsService.getUser(), []);

  const isBetaBatchCoupon = eduzzAccountsService.verifyUserHasBetaModule('cupom_lote');
  const allowedBelts = [
    AllBeltsId.GREEN_BELT,
    AllBeltsId.ORANGE_BELT,
    AllBeltsId.GOLDEN_BELT,
    AllBeltsId.GOLDEN_BELT_D20,
    AllBeltsId.GOLDEN_BELT_D30,
    AllBeltsId.GOLDEN_BELT_D40,
    AllBeltsId.GOLDEN_BELT_D50,
    AllBeltsId.GOLDEN_BELT_D60,
    AllBeltsId.GOLDEN_BELT_D70,
    AllBeltsId.GOLDEN_BELT_D80,
    AllBeltsId.GOLDEN_BELT_D90,
  ];
  const allowChangeHistoryByBelt = allowedBelts.includes(user?.current_elite_level.id);
  const isSupport = user?.is_support;
  const isUnity = user?.is_clube_black;
  const hasParentProduct = parent_product !== 0;
  const oldUrl = `/producer/coupons/${hasParentProduct ? `${parent_product}/` : ''}${id}`;
  const verticalCouponUrl = `${VERTICAL_URL}/coupons?productId=${id}`;
  const couponURL = !isBetaBatchCoupon ? verticalCouponUrl : oldUrl;

  if (statusProduct === 'draft') {
    return (
      <>
        <div className='product__collpase-title'>{'Ações Rápidas '}</div>
        <div className='m8' />
        <MyCollapse title='Links' icon={<Icon style={{ fontSize: 16 }}>link</Icon>} arrow contentActive>
          <div className='helper__title'>
            <InfoSolidIcon size='md' color='#ffd700' /> <Typography className='helper__subtitle'>Finalize o cadastro do seu produto.</Typography>
          </div>
          <p className='helper__text'>
            Falta pouco para você começar a vender na Eduzz, clique em editar e finalize o cadastro desse produto para habilitar o link de venda.
          </p>
        </MyCollapse>
      </>
    );
  }

  return (
    <>
      <div className='product__collpase-title'>Ações Rápidas</div>

      {(isUnity || allowChangeHistoryByBelt || isSupport) && <ProductChangeHistory productData={productDataReceive} />}

      <div className='m8' />

      {!has_children && ((statusProduct && statusProduct === 'active') || statusProduct === 'inactive') && !physicalProductPending && (
        <QuickViewLinks copiedCheckout={copiedCheckout} product={productDataReceive} />
      )}

      {(has_children || (!has_children && parent_product === 0)) &&
        ((statusProduct && statusProduct === 'active') || statusProduct === 'inactive') && (
          <>
            <div className='m8' />
            <MyCollapse title='Adicionar Afiliados' icon={<Icon style={{ fontSize: 16 }}>group_add</Icon>} arrow={true} contentActive={false}>
              <CustomCopyToClipboard text={`${HOST_ORBITA}/affiliate/invite/${id}`} disableUnderline={true} style={{ width: '100%' }} />

              <div className='m8' />

              <InputLabel htmlFor='invite-email' style={{ fontSize: 12 }}>
                Convide por E-mail
              </InputLabel>
              <Input
                id='invite-email'
                type={'text'}
                onChange={(e) => handleChange('inputInviteAffiliate', e)}
                margin='dense'
                fullWidth={true}
                value={inputInviteAffiliate}
                autoFocus={true}
                disableUnderline={true}
                error={!!isValid('inputInviteAffiliate')}
                endAdornment={
                  <InputAdornment position='end'>
                    <IconButton onClick={() => handleClickInviteAffiliate()}>
                      {!productInviteAffiliate.isFetching && (
                        <Tooltip title='Enviar'>
                          <Icon style={{ fontSize: 16 }}>send</Icon>
                        </Tooltip>
                      )}
                      {productInviteAffiliate.isFetching && <CircularProgress size={20} />}
                    </IconButton>
                  </InputAdornment>
                }
              />
              {!isValid('inputInviteAffiliate') ? null : (
                <small
                  style={{
                    fontSize: 12,
                    color: '#dc3f53',
                    textAlign: 'left',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }}
                >
                  {errorFor('inputInviteAffiliate')}
                </small>
              )}
            </MyCollapse>
          </>
        )}

      {((statusProduct && statusProduct === 'active') || statusProduct === 'inactive' || statusProduct === 'filed') &&
        !productData.parent_product && (
          <>
            <div className='m8' />
            <MyCollapse
              title='Ver Afiliados do Produto'
              icon={<Icon style={{ fontSize: 16 }}>people_alt</Icon>}
              arrow={true}
              contentActive={false}
              onClick={() => handleClickGetAffiliatesProductStatusSummary()}
            >
              {affiliatesProductStatusSummary.isFetching && (
                <div style={{ textAlign: 'center', padding: '10px 0' }}>
                  <CircularProgress size={25} style={{ color: '#596375' }} />
                </div>
              )}

              {!affiliatesProductStatusSummary.isFetching && (
                <Table style={{ width: '100%' }}>
                  <TableHead>
                    <TableRow style={{ width: '100%', textAlign: 'center' }}>
                      <TableCell padding='none' style={{ border: 'none', width: '22%', textAlign: 'left' }}>
                        Aprovados
                      </TableCell>
                      <TableCell padding='none' style={{ border: 'none', width: '28%', textAlign: 'left' }}>
                        Reprovados
                      </TableCell>
                      <TableCell padding='none' style={{ border: 'none', width: '28%', textAlign: 'left' }}>
                        Pendentes
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow style={{ width: '100%', textAlign: 'center' }}>
                      <TableCell padding='none' style={{ border: 'none', width: '22%', textAlign: 'left' }}>
                        {approvedAffiliatesAmount}
                      </TableCell>
                      <TableCell padding='none' style={{ border: 'none', width: '28%', textAlign: 'left' }}>
                        {disapprovedAffiliatesAmount}
                      </TableCell>
                      <TableCell padding='none' style={{ border: 'none', width: '28%', textAlign: 'left' }}>
                        {pendingAffiliatesAmount}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              )}
              <Link
                to={`/producer/myaffiliates?p=${id}&status=approved`}
                style={{
                  color: '#596375',
                  fontSize: 12,
                  fontWeight: 600,
                  marginTop: '1rem',
                  float: 'right',
                  textTransform: 'uppercase',
                }}
              >
                VER TODOS OS AFILIADOS
              </Link>
            </MyCollapse>
          </>
        )}

      <div className='m8' />
      <Tooltip
        placement='top'
        title='Entrega manual não é permitida para esse produto. Ou não possui entrega online cadastrada'
        disableFocusListener={!cantManualDelivery}
        disableHoverListener={!cantManualDelivery}
        disableTouchListener={!cantManualDelivery}
      >
        <div>
          <MyCollapse
            disabled={cantManualDelivery}
            title='Entrega Manual'
            icon={<Icon style={{ fontSize: 16 }}>send</Icon>}
            arrow={true}
            contentActive={false}
          >
            <div className='m8' />
            <InputLabel htmlFor='delivery-manual' style={{ fontSize: 12 }}>
              E-mail do Cliente
            </InputLabel>
            <Input
              id='delivery-manual'
              type={'text'}
              onChange={(e) => handleChange('inputDelivery', e)}
              margin='dense'
              error={inputDeliveryError}
              value={inputDelivery}
              fullWidth
              autoFocus={true}
              endAdornment={
                <InputAdornment position='end'>
                  <IconButton onClick={handleClickDelivery}>
                    {!productDelivery.isFetching && !inputDeliveryError && (
                      <Tooltip title='Enviar'>
                        <Icon style={{ fontSize: 16 }}>send</Icon>
                      </Tooltip>
                    )}
                    {!productDelivery.isFetching && inputDeliveryError && (
                      <Tooltip title='Erro ao enviar'>
                        <Icon style={{ fontSize: 16, color: '#f44336' }}>error</Icon>
                      </Tooltip>
                    )}
                    {productDelivery.isFetching && !inputDeliveryError && <CircularProgress size={20} />}
                  </IconButton>
                </InputAdornment>
              }
            />
          </MyCollapse>
        </div>
      </Tooltip>

      {((statusProduct && statusProduct === 'active') || statusProduct === 'inactive' || statusProduct === 'filed') && (
        <>
          <div className='m8' />
          <MyCollapse
            title='Estatísticas'
            icon={<Icon style={{ fontSize: 16 }}>description</Icon>}
            arrow={true}
            contentActive={false}
            onClick={handleClickGetInvoice}
          >
            {productInvoice.isFetching && (
              <div style={{ textAlign: 'center', padding: '10px 0' }}>
                <CircularProgress size={25} style={{ color: '#596375' }} />
              </div>
            )}

            {!productInvoice.isFetching && (
              <Table style={{ width: '100%' }}>
                <TableHead>
                  <TableRow style={{ width: '100%', textAlign: 'center' }}>
                    <TableCell padding='none' style={{ width: '22%', textAlign: 'center' }}>
                      Abertas
                    </TableCell>
                    <TableCell padding='none' style={{ width: '28%', textAlign: 'center' }}>
                      Canceladas
                    </TableCell>
                    <TableCell padding='none' style={{ width: '22%', textAlign: 'center' }}>
                      Pagas
                    </TableCell>
                    <TableCell padding='none' style={{ width: '28%', textAlign: 'center' }}>
                      Reembolsadas
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow style={{ width: '100%', textAlign: 'center' }}>
                    <TableCell padding='none' style={{ width: '22%', textAlign: 'center' }}>
                      {productInvoice.open}
                    </TableCell>
                    <TableCell padding='none' style={{ width: '28%', textAlign: 'center' }}>
                      {productInvoice.canceled}
                    </TableCell>
                    <TableCell padding='none' style={{ width: '22%', textAlign: 'center' }}>
                      <span className='fw600 clgreen'>{productInvoice.paid}</span>
                    </TableCell>
                    <TableCell padding='none' style={{ width: '28%', textAlign: 'center' }}>
                      {productInvoice.refunded}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            )}
          </MyCollapse>
        </>
      )}

      {((!has_children && statusProduct && statusProduct === 'active') || statusProduct === 'inactive') &&
        !(charge_type === 'A' && type === constants.PHYSICAL) &&
        charge_type !== 'L' && (
          <PermissionHide action='myeduzz:meus-produtos:gerenciar-cupons'>
            <>
              <div className='m8' />
              {!isBetaBatchCoupon ? (
                <a id='quickview-coupons-link' href={couponURL} style={couponStyle}>
                  <span style={{ display: 'flex', alignItems: 'center', fontSize: 14, fontWeight: 600, lineHeight: 1 }}>
                    <Icon style={{ fontSize: 16, marginRight: '0.5rem' }}>monetization_on</Icon> Cupons
                  </span>
                  <Icon style={{ fontSize: 24 }}>chevron_right</Icon>
                </a>
              ) : (
                <Link id='quickview-coupons-link' onClick={functions.addScrollPage} to={couponURL} style={couponStyle}>
                  <span style={{ display: 'flex', alignItems: 'center', fontSize: 14, fontWeight: 600, lineHeight: 1 }}>
                    <Icon style={{ fontSize: 16, marginRight: '0.5rem' }}>monetization_on</Icon> Cupons
                  </span>
                  <Icon style={{ fontSize: 24 }}>chevron_right</Icon>
                </Link>
              )}
            </>
          </PermissionHide>
        )}

      {((!has_children && statusProduct && statusProduct === 'active') || statusProduct === 'inactive') && (
        <>
          <div className='m8' />
          <Link
            id='quickview-recovery-messages-link'
            onClick={functions.addScrollPage}
            to={`/producer/rvpmessages/${id}`}
            style={{
              textDecoration: 'none',
              color: '#596375',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              width: '100%',
              padding: '0.75rem 1rem',
              border: '1px solid #EEE',
              background: 'white',
              borderRadius: '4px',
            }}
          >
            <span style={{ display: 'flex', alignItems: 'center', fontSize: 14, fontWeight: 600, lineHeight: 1 }}>
              <Icon style={{ fontSize: 16, marginRight: '0.5rem' }}>message</Icon>Mensagens de Recuperação
            </span>
            <Icon style={{ fontSize: 24 }}>chevron_right</Icon>
          </Link>
        </>
      )}

      <div className='m8' />
      <a
        id='quickview-showcase-link'
        onClick={() => window.open(`${URL_SELECT}/product/details/${id}/source`, '_blank')}
        style={{
          textDecoration: 'none',
          color: '#596375',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          width: '100%',
          padding: '0.75rem 1rem',
          border: '1px solid #EEE',
          background: 'white',
          borderRadius: '4px',
          cursor: 'pointer',
        }}
      >
        <span style={{ display: 'flex', alignItems: 'center', fontSize: 14, fontWeight: 600, lineHeight: 1 }}>
          <Icon style={{ fontSize: 16, marginRight: '0.5rem' }}>view_day</Icon> Vitrine
        </span>
        <Icon style={{ fontSize: 24 }}>chevron_right</Icon>
      </a>
    </>
  );
};

export default QuickActions;
